import { MutationTree, ActionTree, GetterTree } from 'vuex'
import { SET_PRODUCTS } from '../types'
import { RootState } from '../index'

import { cloneDeep } from 'lodash-es'
import { getBase64Id } from '@/utils/general-utils'
import { CollectionProduct, getShopifyCollection } from '@/utils/shopify'

export interface ProductsState {
  allProducts: CollectionProduct[][];
}

const state: ProductsState = { allProducts: [] }

const getters: GetterTree<ProductsState, RootState> = {
  products: (state) => state.allProducts,
}

const mutations: MutationTree<ProductsState> = {
  [SET_PRODUCTS](state, { collectionIndex, products }) {
    const newProducts = [...state.allProducts]
    newProducts[collectionIndex] = products
    state.allProducts = newProducts
  }
}

const actions: ActionTree<ProductsState, RootState> = {
  async loadProducts({ commit, rootGetters }, collectionIndex) {
    const collectionId = rootGetters.getCollectionId(collectionIndex)
    const collection = await getShopifyCollection(collectionId)

    if (collection) {
      const products = collection.products.edges
        .filter((productEdge) => {
          const product = productEdge.node
          if (rootGetters.tag) {
            return product.tags.find(tag => tag === rootGetters.tag)
          } else {
            return !product.tags.find(tag => tag === 'HIDE')
          }
        }).map((productEdge) => {
          const product = productEdge.node
          const newProduct = cloneDeep(product)
          newProduct.id = getBase64Id(newProduct.id)
          return newProduct
        })
      commit(SET_PRODUCTS, { collectionIndex, products })
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
